module.exports = __webpack_public_path__ + "img/9788993642124.e8e13a35.jpg";